'use client';
import { CardSameItemEntityMobile } from '@entities/mobile/cards';
import React from 'react';

import { ItemAge, Nullable, ProductById } from '@/shared/types/common';
import { Illustration, ModalWrapper } from '@/shared/ui';
import { AdditionalInfoMobile } from '@/shared/ui/mobile/additional-info';
import { BottomSheetUi } from '@/shared/ui/mobile/bottom-sheet';

import styles from './confirm-item-navigation.module.scss';

export const ConfirmItemNavigationModal = ({
  isOpened,
  handleClose,
  handleConfirm,
  item,
}: {
  isOpened: boolean;
  item: ProductById;
  handleConfirm: () => void;
  handleClose: () => void;
}) => {
  return (
    <ModalWrapper
      hideBottomSheet={true}
      close={() => handleClose()}
      isOpened={isOpened}
    >
      <ConfirmItemNavigationModal.Content
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        item={item}
      />
    </ModalWrapper>
  );
};

ConfirmItemNavigationModal.Content = ({
  handleClose,
  item,
  handleConfirm,
}: {
  handleClose: () => void;
  handleConfirm: () => void;
  item: ProductById;
}) => {
  return (
    <BottomSheetUi isOpen={true} handleClose={handleClose}>
      <BottomSheetUi.Content className={styles.content}>
        <div>
          <BottomSheetUi.Header onClick={() => {}} className={styles.header}>
            <Illustration
              spriteName={'icons'}
              name={'notes-minimalistic'}
            ></Illustration>
            Item
          </BottomSheetUi.Header>
        </div>
        <CardSameItemEntityMobile
          leftSlot={
            <CardSameItemEntityMobile.Item
              img={item.imageUri}
              rare={item.rare}
              game={item.game}
            />
          }
          middleSlot={
            <CardSameItemEntityMobile.ItemInfo<Nullable<ItemAge> | string>
              price={{
                current: item.price ?? 0,
                old: item.price ?? 0,
              }}
              title={item.age ? item.age : item.name}
              rightSlot={
                <CardSameItemEntityMobile.ItemProperties
                  flyable={item.flyable}
                  rideable={item.rideable}
                />
              }
            />
          }
        />
        <AdditionalInfoMobile variant={'success'}>
          Do you want to go to the item page for {item.name}?
        </AdditionalInfoMobile>
        <BottomSheetUi.Button
          text={'Go'}
          variant={'primary'}
          onClick={handleConfirm}
        />
        <BottomSheetUi.Button
          text={'Close'}
          variant={'secondary'}
          onClick={handleClose}
        />
      </BottomSheetUi.Content>
    </BottomSheetUi>
  );
};
